export const ensureTrailingSlash = (url: string): string => {
  if (!url) {
    return '/';
  }
  return url.endsWith('/') ? url : `${url}/`;
};
